import Videoplayer from "./Videoplayer.vue";
export default Videoplayer;
